var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient';
import { authApi } from 'root/src/shared/util/authApi';
import { POST_SIGN_UP_ENDPOINT_URL } from 'root/src/shared/constants/auth';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
export const signUpToken = (params) => () => __awaiter(void 0, void 0, void 0, function* () {
    const code = new URL(window.location.href).searchParams.get('code');
    if (!code) {
        throw new Error('Cannot find code, please contact support');
    }
    yield authApi.createCredentials({
        code,
        email: params.email,
        password: params.password,
        redirectUrl: POST_SIGN_UP_ENDPOINT_URL,
    });
    return pushRouteClient({ href: routeUrls.verifyAccount() });
});
